module.exports = __webpack_public_path__ + "img/streak-progressbar-rocket.d85faa97.svg";